function v(e, r, ...t) {
  if (typeof console > "u")
    return;
  const n = console[e];
  n && n(r, ...t);
}
const j = (e, ...r) => {
  v("log", e, ...r);
}, x = (e, ...r) => {
  v("info", e, ...r);
}, S = (e, ...r) => {
  v("warn", e, ...r);
}, N = (e, ...r) => {
  v("error", e, ...r);
}, G = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  error: N,
  info: x,
  log: j,
  warn: S
}, Symbol.toStringTag, { value: "Module" }));
function _(e) {
  var r;
  return ((r = e == null ? void 0 : e["@path"]) == null ? void 0 : r.replace(/\//g, "_")) || (e == null ? void 0 : e["@name"]) || "";
}
function b(e, r = {}, t, n) {
  if (!e || typeof e != "object")
    return {};
  const i = {
    ...r,
    metadata: { "@index": t },
    key: _(e)
  };
  let l;
  return n ? (i.data = {}, l = i.data) : l = i, Object.keys(e).forEach((a) => {
    a.match(/^(@|mgnl:|jcr:)/) ? i.metadata[a] = e[a] : l[a.replace("-", "_")] = e[a];
  }), i;
}
const $ = (e, r, t) => (S(
  "This getComponentProperties method is deprecated. Use buildComponentProperties instead."
), b(
  e,
  void 0,
  r,
  t
)), Q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  buildComponentProperties: b,
  buildKey: _,
  getComponentProperties: $
}, Symbol.toStringTag, { value: "Module" }));
function A(e) {
  try {
    const r = /^http(s?):\/\//i.test(e) ? e : "http://valid-url.com" + (e.startsWith("/") ? e : "/" + e);
    return new URL(r);
  } catch {
    return console.warn("requestUrl is not a valid URL"), !1;
  }
}
function O(e) {
  return new RegExp(`/${e}($|/)`);
}
const D = (e, r, t) => {
  const n = A(e), i = {
    isMagnolia: !1,
    isMagnoliaEdit: !1,
    isMagnoliaPreview: !1,
    version: void 0,
    nodePath: void 0,
    currentLanguage: void 0,
    searchParams: void 0,
    search: void 0
  };
  if (n) {
    const l = n.pathname, a = new URLSearchParams(n.search), o = a.get("mgnlPreview"), d = a.get("mgnlPreviewAsVisitor"), f = a.get("mgnlVersion"), g = o ?? d;
    g && (i.isMagnolia = !0, g === "false" && (i.isMagnoliaEdit = !0), g === "true" && (i.isMagnoliaPreview = !0)), i.isMagnolia && !d && a.set("variants", "all"), f ? (i.version = f, a.set("version", f)) : delete i.version;
    let c = l, p = !1;
    if (t && t.length > 0 && (i.currentLanguage = t[0], p = t.some((u) => O(u).test(c) ? (i.currentLanguage = u, !0) : !1), a.set("lang", i.currentLanguage)), r) {
      p && (c = c.replace(
        O(i.currentLanguage),
        "/"
      ));
      const u = new RegExp("(.html|/$)"), E = new RegExp(`^${r}($|/)`);
      c = c.replace(E, "/").replace(u, ""), i.nodePath = r + c;
    }
    i.searchParams = Object.fromEntries(a), i.search = "?" + a.toString();
  }
  return i;
};
function z() {
  var R;
  const e = () => {
    try {
      const { href: s } = window.parent.location;
      return s != null;
    } catch {
      return !1;
    }
  };
  function r() {
    if (!(typeof window > "u"))
      return e() ? window.parent : window;
  }
  const t = {
    serverUrl: e() && typeof window < "u" ? (R = r()) == null ? void 0 : R.location.href : ""
  }, n = (s) => new Promise((m) => {
    setTimeout(m, s);
  }), i = async (s, m, w = 5e3) => {
    for (; !s(); )
      if (await n(200), w > 0 && m && Date.now() - m.getTime() > w) {
        S("Wait timeout");
        break;
      }
    return s();
  }, l = () => typeof window < "u" ? window !== window.parent : !1, a = () => {
    const s = r();
    return new URLSearchParams(s == null ? void 0 : s.location.search).get(
      "mgnlPreviewAsVisitor"
    ) === "true";
  }, o = () => {
    var s;
    return !!((s = t.serverUrl) != null && s.endsWith(":edit"));
  }, d = async (s) => {
    var m;
    return await i(() => {
      var w;
      return ((w = t.serverUrl) == null ? void 0 : w.length) || !1;
    }, /* @__PURE__ */ new Date(), s), !!((m = t.serverUrl) != null && m.endsWith(":edit"));
  }, f = () => {
    var s;
    return !!((s = t.serverUrl) != null && s.endsWith(":view"));
  }, g = () => o() || !t.serverUrl;
  let c = null;
  const p = (s) => {
    c && clearTimeout(c), c = setTimeout(u, s);
  }, u = () => {
    const s = r();
    s != null && s.mgnlRefresh && (document.documentElement.innerHTML.indexOf("cms:page content=") > -1 ? s.mgnlRefresh() : p(200));
  };
  return {
    isSameOrigin: e,
    inIframe: l,
    inEditorAsync: d,
    inEditorPreview: f,
    inPreviewAsVisitor: a,
    isRenderingAnnotation: g,
    isPageEditorReady: () => {
      const s = r();
      return (s == null ? void 0 : s.mgnlFrameReady) !== void 0;
    },
    onFrameReady: () => {
      const s = r();
      s != null && s.mgnlFrameReady && s.mgnlFrameReady();
    },
    setServerUrl: (s) => {
      t.serverUrl = s;
    },
    inEditor: o,
    refresh: p,
    getMagnoliaContext: D
  };
}
const h = z(), T = "selectedComponentVariants", y = (e, r, t) => {
  if (!r || typeof t != "function")
    return;
  const n = r.toLowerCase();
  e[n] = e[n] || [], e[n].push(t);
};
function M(e) {
  const r = new URL(e);
  return `${r.protocol}//${r.hostname}${r.port ? `:${r.port}` : ""}${r.pathname.substring(0, r.pathname.indexOf(".magnolia"))}`;
}
function C(e, r) {
  return r ? e[r.toLowerCase()] || [] : [];
}
function F(e, r) {
  var o;
  const t = "mgnlPageEditorBridge";
  let n = document.getElementById(
    t
  );
  if (n || !r) {
    typeof e == "function" && e();
    return;
  }
  const i = M(r), l = document.getElementsByTagName("script")[0];
  n = document.createElement("script"), n.id = t, n.src = `${i}VAADIN/widgetsets/info.magnolia.PageEditor/info.magnolia.PageEditor.nocache.js`, (o = l.parentNode) == null || o.insertBefore(n, l), n.onload = () => {
    setTimeout(function d() {
      h.isPageEditorReady() ? (h.onFrameReady(), h.refresh(), typeof e == "function" && e()) : setTimeout(d, 100);
    }, 50);
  };
  const a = document.createElement("link");
  a.href = `${i}VAADIN/themes/pages-app/page-editor.css`, a.type = "text/css", a.rel = "stylesheet", document.head.insertBefore(a, document.head.firstChild);
}
const L = () => {
  const e = {
    element: {
      dialog: "",
      path: "/",
      workspace: "website"
    },
    action: "initialize",
    elementType: "page"
  };
  window.parent.postMessage(JSON.stringify(e), "*");
}, W = (e, r) => {
  typeof window > "u" || h.isSameOrigin() || (window.addEventListener("message", (t) => {
    if (!t.data || !(typeof t.data == "string" && t.data.startsWith("{")))
      return;
    const n = JSON.parse(t.data);
    C(e, n.action).forEach((l) => {
      try {
        l(n);
      } catch (a) {
        console.error(a);
      }
    });
  }), y(e, "updateState", (t) => {
    const n = t.serverUrl;
    h.setServerUrl(n), F(r, n);
  }), L());
}, B = (e, r) => typeof e == "object" && Object.keys(e).length > 0 ? JSON.stringify(e) !== r.get(T) : !1, I = (e, r) => {
  y(e, "updateState", (t) => {
    const n = t, i = new URL(window.location.href);
    B(
      n.selectedComponentVariants,
      i.searchParams
    ) && (i.searchParams.set(
      T,
      JSON.stringify(n.selectedComponentVariants)
    ), r ? (window.history.pushState({}, "", i.toString()), window.dispatchEvent(new Event("popstate"))) : window.location.href = i.toString());
  });
}, X = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getBaseServerUrl: M,
  init: W,
  initialVariantsHandler: I,
  onMessage: y,
  requestServerUrl: L
}, Symbol.toStringTag, { value: "Module" }));
function U(e, r) {
  if (!e || !r)
    return e;
  const t = JSON.parse(JSON.stringify(e));
  return Object.keys(r).forEach((n) => {
    if (n.includes(e == null ? void 0 : e["@path"]) && r[n].startsWith("cms:area")) {
      const i = n.split("/").pop();
      i && !(i in e) && (t[i] = {
        "@path": `${e == null ? void 0 : e["@path"]}/${i}`,
        "@nodes": [],
        "@id": `${e == null ? void 0 : e["@path"]}/${i}`
      });
    }
  }), t;
}
const Y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  generateMissingAreas: U
}, Symbol.toStringTag, { value: "Module" })), P = (e, r) => {
  if (!e || !r)
    return e;
  const t = r[e == null ? void 0 : e["@path"]], n = t ? t.match(/selectedVariant="(.+)"/) : null;
  if (!n) return e;
  const i = n[1];
  return i === e["@name"] ? e : e[i] ? e[i] : null;
}, J = (e, r) => !h.inIframe() || h.inPreviewAsVisitor() ? e : P(e, r), V = (e, r) => {
  if (!e || !r)
    return e;
  const t = {}, n = /selectedVariant="(.+?)"/, i = /content="(.+?)"/, l = /((variants|variantTitles)=".+?")/g;
  return Object.entries(e).forEach((a) => {
    var f, g;
    const [o, d] = a;
    if (n.test(d) && o in r) {
      let c = r[o];
      if (c === "original")
        c = o.split("/").pop(), t[o] = d.replace(
          n,
          `selectedVariant="${c}"`
        );
      else {
        const p = o + "/variants/" + c, u = e[p];
        u != null ? (t[o] = u.replace(
          i,
          ((f = d.match(i)) == null ? void 0 : f[0]) || ""
        ), t[o] = t[o].concat(
          " ",
          ((g = d.match(l)) == null ? void 0 : g.join(" ")) || ""
        ), t[o] = t[o].concat(
          " ",
          `selectedVariant="${c}"`
        )) : S(
          "Cannot find the variant with path '%s'. Please review the document https://docs.magnolia-cms.com/headless/spa-development/personalization-of-headless-SPA-projects.html#_notes.",
          p
        );
      }
    }
  }), { ...e, ...t };
}, q = (e, r, t) => {
  let n;
  !r || !t ? n = r || {} : n = V(
    r,
    t
  );
  let i = U(
    e,
    n
  );
  return i = P(i, n), {
    content: i,
    templateAnnotations: n
  };
}, Z = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getRenderContent: q,
  getSelectedVariant: P,
  getVariant: J,
  wrap: V
}, Symbol.toStringTag, { value: "Module" })), k = {
  TEMPLATE_ID_PROP: "mgnl:template",
  END_AREA_COMMENT: "/cms:area",
  END_COMPONENT_COMMENT: "/cms:component"
};
export {
  k as Constants,
  Q as ContentRendererService,
  h as EditorContextService,
  G as LoggerService,
  X as PageEditorBridge,
  Z as PersonalizationService,
  Y as TemplateAnnotationsService
};
//# sourceMappingURL=frontend-helpers-base.js.map
